import PropTypes from 'prop-types';
import React from 'react';

class MemberDetail extends React.Component {
  render() {
    const { member } = this.props;
    return (
      <div className="container">
        <div className="row">
          <div className="col-md-4">
            <h4>{member.first_name} {member.last_name}</h4>
            <p>{member.email}</p>
            <p>{member.phone_number}</p>
            <p>{member.title}</p>
            <h4>{member.group.name}</h4>
          </div>
          <div className="col-md-4">
          </div>
        </div>
        <div className="row">
          <div className="col-md-8"> </div>
        </div>
      </div>
    );
  }
}


MemberDetail.propTypes = {
  member: PropTypes.object.isRequired,
  // sendProposal: PropTypes.func.isRequired,
};

export default MemberDetail;



// WEBPACK FOOTER //
// src/routes/tours/components/MemberDetail.js